import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { format } from 'date-fns';
import { pick, sortBy } from 'lodash-es';
import { makeInvoiceDateInfo } from '~/business-logic/billingLogic';
import { invoiceDraftModel, relationshipModel, timeModel } from '~/models';
import { LineItemType } from '~/models/invoice-draft';
export const billingHubTextsPath = 'billingHub';
export var BillingHubUrlParams = /*#__PURE__*/ function(BillingHubUrlParams) {
    BillingHubUrlParams["SelectedDate"] = "selectedDate";
    BillingHubUrlParams["ClientId"] = "clientId";
    BillingHubUrlParams["RelationshipId"] = "relationshipId";
    return BillingHubUrlParams;
}({});
export const testPrefix = 'billing-hub-';
export function dateToString(date) {
    let variant = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'default';
    if (variant === 'default') {
        return format(date, 'PPP');
    } else {
        // Formatting requirements: Jan, Feb, **March**, **April**, May, **June**, **July**, Aug, Sep, Oct, Nov, Dec
        const longFormatMonths = new Set([
            3,
            4,
            6,
            7
        ]);
        const monthFormat = longFormatMonths.has(date.getMonth() + 1) ? 'LLLL' : 'LLL';
        return format(date, "".concat(monthFormat, " do, y"));
    }
}
export function getLineItemsProps(invoiceDraft, onApprove, onRemove, isVendor) {
    const unsortedLineItems = invoiceDraft.lineItems.map((lineItem)=>{
        return {
            charge: getLineItemChargeProps(lineItem, isVendor),
            onApprove: ()=>onApprove(lineItem.id),
            onRemove: ()=>onRemove(lineItem.id, {
                    billLaterCommandId: invoiceDraftModel.billLaterCommandId(lineItem),
                    serviceId: invoiceDraftModel.serviceId(lineItem)
                })
        };
    });
    return sortBy(unsortedLineItems, getSortingRank);
}
const lineItemTypeToRank = {
    [LineItemType.AdHocCharge]: 1,
    [LineItemType.Manual]: 2,
    [LineItemType.Automatic]: 3,
    [LineItemType.Credit]: 4
};
function getSortingRank(lineItemProps) {
    const typeRank = lineItemTypeToRank[lineItemProps.charge.type];
    return "".concat(typeRank).concat(lineItemProps.charge.name.toLowerCase()).concat(lineItemProps.charge.id);
}
function getLineItemChargeProps(lineItem, isVendor) {
    const shouldHaveANegativeValue = invoiceDraftModel.isCredit(lineItem);
    const totalAmount = shouldHaveANegativeValue ? lineItem.totalAmount.negated() : lineItem.totalAmount;
    const rate = _object_spread_props(_object_spread({}, lineItem.rate), {
        amount: shouldHaveANegativeValue ? lineItem.rate.amount.negated() : lineItem.rate.amount
    });
    return _object_spread_props(_object_spread({}, pick(lineItem, [
        'id',
        'name',
        'note'
    ])), {
        totalAmount,
        rate,
        type: lineItem.source,
        discount: invoiceDraftModel.discount(lineItem) || undefined,
        pendingApprovalReason: invoiceDraftModel.pendingApprovalReason(lineItem) || undefined,
        quantity: invoiceDraftModel.quantity(lineItem) || undefined,
        integrations: lineItem.source === LineItemType.Automatic || lineItem.source === LineItemType.Manual ? lineItem.integrations : undefined,
        subLineItems: (lineItem.source === LineItemType.Automatic || lineItem.source === LineItemType.Manual) && isVendor ? lineItem.subLineItems : undefined
    });
}
export const getInvoiceDateInfo = (selectedDate, invoicesDraftDates)=>selectedDate && invoicesDraftDates.dates().length > 0 ? makeInvoiceDateInfo(invoicesDraftDates, selectedDate) : undefined;
export function getEmptyState(relationship, texts) {
    if (relationshipModel.isTerminated(relationship)) {
        return {
            text: texts.agreementEmptyState.terminated(),
            paragraphs: []
        };
    } else if (relationshipModel.isPending(relationship)) {
        return {
            text: relationship.effectiveDate ? texts.agreementEmptyState.willBeInEffect({
                date: timeModel.formatDate(relationship.effectiveDate)
            }) : texts.agreementEmptyState.notSigned(),
            paragraphs: [
                texts.agreementEmptyState.pendingDescription()
            ]
        };
    } else {
        return null;
    }
}
export const getNoInvoicesText = (selectedDate, isVendor, texts)=>selectedDate ? texts.noScheduledInvoices.forSelectedDate() : texts.noScheduledInvoices.none() + (isVendor ? texts.noScheduledInvoices.clickBillingControlToCreate() : '');
